import { AmplifilesClient } from "./api-client";
import {
  SelfDto,
  IntercomMessengerPayloadDto,
  CreateApiKeyDto,
  ApiKeyDto,
  SubmitOnboardingSurveyDto,
  SetUserFlagsDto,
} from "@repo/api/user";

export class UserApi {
  static async getSelf() {
    const response = await AmplifilesClient.instance.get("/user/self");
    return SelfDto.parse(response.data);
  }

  static async getIntercomMessengerPayload() {
    const response = await AmplifilesClient.instance.get("/user/self/intercom");
    return IntercomMessengerPayloadDto.parse(response.data);
  }

  static async createApiKey(data: CreateApiKeyDto) {
    const response = await AmplifilesClient.instance.post(
      "/user/api-key",
      data,
    );
    return ApiKeyDto.parse(response.data);
  }

  static async submitOnboardingSurvey(data: SubmitOnboardingSurveyDto) {
    const response = await AmplifilesClient.instance.post(
      "/user/self/onboarding-survey",
      data,
    );
    return SelfDto.parse(response.data);
  }

  static async setUserFlags(data: SetUserFlagsDto) {
    const response = await AmplifilesClient.instance.post(
      "/user/self/flags",
      data,
    );
    return SelfDto.parse(response.data);
  }
}
